export function shouldAllowMobileTrainEntry(search: string): boolean {
  const params = new URLSearchParams(search);
  return (
    params.get("free") === "true" ||
    params.has("personaId") ||
    params.has("scenarioId") ||
    params.has("vehicleId") ||
    params.get("from") === "coach" ||
    params.has("briefId") ||
    params.get("dev_call_ui") === "1" ||
    params.get("mock_call") === "1"
  );
}
